import { Any, Arr, Obj } from "@kizmann/pico-js";
import AppService from "#pub/service/AppService.js";

export default {

    name: 'CrudForm',

    config: {
        // Form config
    },

    inject: {

        CrudIndex: {
            default: undefined
        },

        NDrawer: {
            default: undefined
        }

    },

    data()
    {
        return {
            load: false, data: {}
        };
    },

    watch: {

        '$route.params.id': function () {
            this.fetchItem();
        },

    },

    mounted()
    {
        this.fetchItem();
    },

    methods: {

        submitForm()
        {
            let errors = this.$refs.form.validate();

            if ( Any.keys(errors).length ) {
                return;
            }

            this.patchItem();
        },

        fetchItem()
        {
            let id = Obj.get(this.$route, 'params.id');

            if ( Any.isEmpty(id) ) {
                return;
            }

            let curl = this.CrudIndex.ctor('crud.show');

            if ( Any.isEmpty(curl) ) {
                console.error('Url crud.show is missing in ' + this.ctor('name'))
            }

            let config = {
                onLoad: () => this.load = true,
                onDone: () => this.load = false,
            };

            let url = AppService.paramUrl(curl, {
                id
            });

            AppService.fetchData(url, config)
                .then((res) => {
                    this.data = res.data.data;
                })
                .catch(() => {
                    this.CrudIndex.gotoIndex();
                });
        },

        patchItem()
        {
            let [id, curl] = [
                Obj.get(this.$route, 'params.id'), this.CrudIndex.ctor('crud.update')
            ];

            if ( Any.isEmpty(id) ) {
                curl = this.CrudIndex.ctor('crud.create')
            }

            if ( Any.isEmpty(curl) ) {
                console.error('Url crud.create/crud.update is missing in ' + this.ctor('name'))
            }

            let config = {
                onLoad: () => this.load = true,
                onDone: () => this.load = false,
            };

            config.apx = [
                this.CrudIndex.ctor('name'), curl
            ];

            let url = AppService.paramUrl(curl, {
                id
            });

            AppService.postData(url, this.data, config)
                .then((res) => {
                    this.CrudIndex.gotoItem(res.data.data);
                })
                .catch(() => {
                    //
                });
        }

    },

    renderForm()
    {
        let configProps = {
            scope: this, config: this.ctor('config')
        };

        return (
            <NForm ref="form" form={this.data}>
                <NConfigNext vModel={this.data} {...configProps} />
            </NForm>
        );
    },

    renderContent()
    {
        return (
            <NScrollbar class="crud-form__content">
                {this.ctor('renderForm')()}
            </NScrollbar>
        );
    },

    renderClose()
    {
        let buttonProps = {
            type: 'neutral',
            glass: true,
            link: true,
        };

        buttonProps['onClick'] = () => {
            this.NDrawer.closeDrawer();
        };

        return (
            <div>
                <NButton {...buttonProps}>{this.trans('Discard')}</NButton>
            </div>
        )
    },

    renderSave()
    {
        let buttonProps = {
            //
        };

        buttonProps['onClick'] = () => {
            this.submitForm();
        };

        return (
            <div>
                <NButton {...buttonProps}>{this.trans('Apply')}</NButton>
            </div>
        )
    },

    renderFooter()
    {
        return (
            <div class="crud-form__footer">
                {this.ctor('renderClose')()}
                {this.ctor('renderSave')()}
            </div>
        );
    },

    render()
    {
        let ctors = [
            'renderContent',
            'renderFooter',
        ];
        return (
            <NLoader class="crud-form" visible={this.load}>
                {Arr.each(ctors, (fx) => this.ctor(fx)())}
            </NLoader>
        )
    }

}